<template>
    <div class="d-flex align-center justify-center justify-sm-space-between pa-3">
        <div class="d-flex align-center">
            <v-btn class="px-1 px-sm-3" variant="text" size="small" :disabled="loading || page == 1" @click="page = 1"><v-icon size="18">keyboard_double_arrow_right</v-icon> اولین</v-btn>
            <v-btn class="px-1 px-sm-3" variant="text" size="small" :disabled="loading || page == 1" @click="page = page - 1 >= lastPage ? lastPage : page - 1"><v-icon size="18">chevron_right</v-icon> قبلی</v-btn>
            <p class="mx-5 mx-sm-9 text-small">نمایش {{ startNumber }}{{ endNumber }} از {{ totalItems }}</p>
            <v-btn class="px-1 px-sm-3" variant="text" size="small" :disabled="loading || page >= lastPage" @click="page++">بعدی <v-icon size="18">chevron_left</v-icon></v-btn>
            <v-btn class="px-1 px-sm-3" variant="text" size="small" :disabled="loading || page >= lastPage" @click="page = lastPage">آخرین <v-icon size="18">keyboard_double_arrow_left</v-icon></v-btn>
        </div>
        <div class="d-flex align-center">
            <p class="d-none d-sm-block me-3 text-small">تعداد ردیف:</p>
            <v-select :disabled="loading" class="ma-0 pa-0 d-none d-sm-block" hide-details :items="[10, 25, 50]" style="max-width: 100px;" label="" v-model="perPage" @update:modelValue="page = 1" :value-comparator="(a, b) => a == b"></v-select>
        </div>
    </div>
</template>

<script setup>
const emit = defineEmits(['updated']);
const { totalItems, loading = false } = defineProps(['totalItems', 'loading']);
const page = defineModel('page');
const perPage = defineModel('perPage');
const lastPage = computed(() => {
    let currentPage = Math.ceil(totalItems / perPage.value);
    return currentPage > 0 ? currentPage : 1;
});
const startNumber = computed(() => {
    let nubmer = ((page.value - 1) * perPage.value) + 1;
    return nubmer > totalItems ? 0 : (nubmer + ' تا ');
});
const endNumber = computed(() => {
    if (startNumber.value === 0) return '';
    let nubmer = (page.value) * perPage.value;
    return (nubmer > totalItems ? totalItems : nubmer);
});
watch([page, perPage], () => {
    emit('updated');
});
</script>
